import { Button } from "@/components/ui/button";
import ImageSvg from "@/components/ui/image-svg";
import { Input } from "@/components/ui/input";
import { toast } from "@/components/ui/use-toast";
import { recoverPassword } from "@/services/clientAreaService";
import { ArrowRight, Loader2 } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await recoverPassword(email);
      setSubmitted(true);
      toast({
        title: "Sucesso!",
        description: "Link de recuperação enviado para seu e-mail!",
        variant: "green",
        style: {
          position: "fixed",
          top: 24,
          right: 24,
          zIndex: 9999,
          maxWidth: 400,
          width: "100%",
        },
      });
      setTimeout(() => {
        navigate(`/esqueci-senha/verify-code/${encodeURIComponent(email)}`);
      }, 3000);
    } catch {
      toast({
        title: "Erro",
        description: "Erro ao enviar solicitação de recuperação de senha.",
        variant: "destructive",
        style: {
          position: "fixed",
          top: 24,
          right: 24,
          zIndex: 9999,
          maxWidth: 400,
          width: "100%",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen md:px-10 md:py-20 px-5 py-10">
      <div className="flex flex-col md:flex-row items-center justify-center gap-10 md:gap-0">
        <div className="bg-white max-w-[600px] rounded-[20px] w-full md:w-1/2 flex flex-col items-center justify-center px-10 space-y-8 py-12 shadow">
          <h1 className="text-4xl md:text-5xl font-bold text-center text-n-text-green">
            Recuperar senha
          </h1>
          <p className="text-md md:text-lg text-center text-n-text-neutral max-w-md">
            Vamos recuperar a sua senha. Informe o email cadastrado em sua
            conta. Um email com o passo-a-passo para a recuperação será enviado.
          </p>

          {!submitted ? (
            <form
              onSubmit={handleSubmit}
              className="w-full max-w-xl flex flex-col space-y-8"
            >
              <Input
                type="email"
                placeholder="Email/CPF"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <div className="flex justify-end w-full">
                <Button type="submit" disabled={loading}>
                  {loading ? (
                    <>
                      Enviando...
                      <Loader2 size={20} className="ml-3 animate-spin" />
                    </>
                  ) : (
                    <>
                      Prosseguir
                      <ArrowRight size={20} className="ml-3" />
                    </>
                  )}
                </Button>
              </div>
            </form>
          ) : (
            <div className="text-center space-y-4">
              <p className="text-n-secondary">
                Link de recuperação enviado para seu e-mail!
              </p>
              <p className="text-sm text-n-text">
                Verifique sua caixa de entrada e spam
              </p>
            </div>
          )}
        </div>

        <div className="w-full md:w-1/2 hidden md:flex items-center justify-center mt-10 md:mt-0">
          <ImageSvg
            src={"concept-company.svg"}
            alt="Esqueci minha senha"
            className="w-[400px] md:w-[600px]"
          />
        </div>
      </div>
    </div>
  );
}
